export default __webpack_public_path__ + "static/media/OpenSans-Italic.7e20bd37.woff";